import React, { Component, useEffect, useState } from 'react';
import { isHebrew } from '../../../App';
import { makeStyles } from '@material-ui/core/styles';
import HomeVideoWidget from '../../../components/pages/Homepage/Videos/HomeVideoWidget';
import { Box, Grid, Modal } from '@material-ui/core';
import { BodyText, HeadingText } from './TextHelpers';
import VideoCard from './VideoCard';
import { Image } from '../../../components/image/image.component';
import { lclDirection } from '../../../utils/vlStrings';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#0e091e',
    minHeight: '100vh',
  },
  hero: {
    minHeight: '70vh',
  },
  videoModalContainer: {
    height: '620px',
    width: '380px',
    maxWidth: '100%',
    borderRadius: '32px',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  headerText: {
    width: '75%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}));

const VideoModal = (props) => {
  const { open, handleClose, imageURL, videoURL, isSmall } = props;
  const [isLoadingVideo, setIsLoadingVideo] = useState(true);
  const classes = useStyles({ isHebrew: isHebrew() });
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          style={{
            position: 'absolute',
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
          }}
        >
          <Box className={classes.videoModalContainer}>
            <HomeVideoWidget
              previewMode={true}
              visibile={true}
              isSmall={isSmall}
              horizontal={false}
              key={'some_id'}
              index={0}
              fill={true}
              videoURL={videoURL}
              imageURL={imageURL}
              discover={false}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

const videoItems = [
  {
    title: 'Announcement',
    detail: 'Facebook Israel',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634055652/kre8.tv/landing_pages/biz_tal_moserri_facebook_ljwlri.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634055652/kre8.tv/landing_pages/biz_tal_moserri_facebook_ljwlri.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062244/kre8.tv/landing_pages/j9WrD251LjG_r5kpxr.png',
  },
  {
    title: 'Marketing',
    detail: 'Captain Check',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/so_3.5/v1634055903/kre8.tv/landing_pages/biz_zeev_revach_capti_check_cjepup.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634055903/kre8.tv/landing_pages/biz_zeev_revach_capti_check_cjepup.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062321/kre8.tv/landing_pages/137217196_239612030899747_1976613621320780105_n.jpg_gsmzsw.jpg',
  },
  {
    title: 'Announcement',
    detail: 'TAU',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634197910/kre8.tv/landing_pages/biz_tau_uni_mor_x8ioot.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634197910/kre8.tv/landing_pages/biz_tau_uni_mor_x8ioot.mov',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634198191/kre8.tv/landing_pages/A6a9eimtHZaNqr9FDpkq8ha-0dxJcMjCymYgibidpdwlAU85QrfxMphJeA-gKYuLuyme_wkkljd.png',
  },
  {
    title: 'Marketing',
    detail: 'Veritas',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/so_0.1/v1634062795/kre8.tv/landing_pages/biz_veritas_uri_g_ledkt6.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634062795/kre8.tv/landing_pages/biz_veritas_uri_g_ledkt6.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062942/kre8.tv/landing_pages/Screen_Shot_2021-10-12_at_21.22.14_tzxpad.png',
  },
  {
    title: 'Announcement',
    detail: 'Swimm',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634061759/kre8.tv/landing_pages/biz_idan_alterman_swim_b6611u.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634061759/kre8.tv/landing_pages/biz_idan_alterman_swim_b6611u.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062230/kre8.tv/landing_pages/squarelogo_m4omz1.png',
  },
];

const videoItems_hebrew = [
  {
    title: 'הודעה מיוחדת',
    detail: 'פייסבוק ישראל',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634055652/kre8.tv/landing_pages/biz_tal_moserri_facebook_ljwlri.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634055652/kre8.tv/landing_pages/biz_tal_moserri_facebook_ljwlri.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062244/kre8.tv/landing_pages/j9WrD251LjG_r5kpxr.png',
  },
  {
    title: 'שיווק',
    detail: 'קפטן צ׳ק',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/so_3.1/v1634055903/kre8.tv/landing_pages/biz_zeev_revach_capti_check_cjepup.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634055903/kre8.tv/landing_pages/biz_zeev_revach_capti_check_cjepup.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062321/kre8.tv/landing_pages/137217196_239612030899747_1976613621320780105_n.jpg_gsmzsw.jpg',
  },
  {
    title: 'הודעה מיוחדת',
    detail: 'אוניברסיטת ת״א',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634197910/kre8.tv/landing_pages/biz_tau_uni_mor_x8ioot.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634197910/kre8.tv/landing_pages/biz_tau_uni_mor_x8ioot.mov',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634198191/kre8.tv/landing_pages/A6a9eimtHZaNqr9FDpkq8ha-0dxJcMjCymYgibidpdwlAU85QrfxMphJeA-gKYuLuyme_wkkljd.png',
  },
  {
    title: 'שיווק',
    detail: 'וריטס',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/so_0.1/v1634062795/kre8.tv/landing_pages/biz_veritas_uri_g_ledkt6.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634062795/kre8.tv/landing_pages/biz_veritas_uri_g_ledkt6.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062942/kre8.tv/landing_pages/Screen_Shot_2021-10-12_at_21.22.14_tzxpad.png',
  },
  {
    title: 'הודעה מיוחדת',
    detail: 'Swimm',
    imageURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634061759/kre8.tv/landing_pages/biz_idan_alterman_swim_b6611u.jpg',
    videoURL:
      'https://res.cloudinary.com/kre8-tv/video/upload/v1634061759/kre8.tv/landing_pages/biz_idan_alterman_swim_b6611u.mp4',
    companyImageURL:
      'https://res.cloudinary.com/kre8-tv/image/upload/v1634062230/kre8.tv/landing_pages/squarelogo_m4omz1.png',
  },
];

const texts = {
  title: 'The CREATIVE solutions that will help you GROW',
  detail:
    'Unleash your brand’s power with KRE8.TV by partnering to create custom video content for business, resourced at scale. Unleash the enless possibilities of content marketing - KRE8.TV puts unprecedented access to celebrities and groundbreaking production techniques at your disposal',
};

const texts_hebrew = {
  title: 'מצאו את הכוכבים הנכונים להגדיל את העסק שלכם',
  detail:
    'נצלו את הכוח של תוכן וידאו להמונים ותעזרו ביוצרים של קריאייט בצורה מהירה ופשוטה. קבלו גישה בלתי מוגבלת עם מגוון אפשרויות שתעזור לכם להגיע ולתקשר עם יותר לקוחות בצורה הכי אפקטיבית שיש ',
};

export const Hero = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const [showItem, setShowItem] = useState(null);
  const onVideoClicked = (item) => {
    setShowItem(item);
  };
  const { isSmall } = props;
  const { title, detail } = isHebrew() ? texts_hebrew : texts;
  const items = isHebrew() ? videoItems_hebrew : videoItems;

  return (
    <Box
      width="100%"
      className={classes.hero}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Grid container spacing={3}>
        <Grid item xs="12" md="6">
          <Box
            className={classes.headerText}
            height="100%"
            color="white"
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <HeadingText fontSize="36px" lineHeight="48px">
              {title}
            </HeadingText>
            <BodyText mt={2} fontSize="18px" width="75%">
              {detail}
            </BodyText>
          </Box>
        </Grid>
        <Grid item xs="12" md="6">
          <Box
            display="flex"
            flexDirection="row"
            flexWrap="nowrap"
            minWidth="100%"
            overflow="auto"
          >
            {items.map((item, index) => {
              return (
                <Box
                  flexShrink={0}
                  m={2}
                  className="clickable"
                  onClick={() => onVideoClicked(item)}
                  style={{ width: '240px', height: '370px' }}
                >
                  <VideoCard
                    title={item.title}
                    detail={item.detail}
                    imageURL={item.imageURL}
                    videoURL={item.videoURL}
                    companyImageURL={item.companyImageURL}
                  />
                </Box>
              );
            })}
          </Box>
        </Grid>
      </Grid>
      {showItem ? (
        <VideoModal
          isSmall={isSmall}
          handleClose={() => setShowItem(null)}
          open={showItem}
          imageURL={showItem?.imageURL}
          videoURL={showItem?.videoURL}
        />
      ) : null}
    </Box>
  );
};
